<template>
  <div class="marketplace left">
    <div class="padding p-top">
      <img src="../assets/profilotesti.png" class="profilotesti" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Marketplace",
  components: {}
};
</script>

<style lang="less" scoped>
.profilotesti {
  width: 70vw;
  margin: auto;
}
.padding {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
}
.p-top {
  padding-top: 30px;
}
.lista {
  width: 100%;
  overflow: auto;
  padding-left: 10px;
}
</style>
